"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";
import PalettePanel from "../ui/overlays/PalettePanel";
import PaletteButton from "./PaletteButton";
import OutlineFilter from "../shaders/OutlineFilter";

export default class HUD extends PIXI.Container {
    constructor() {
        super();

        // Attributes.
        this._leftBarContainer = null;
        this._rightBarContainer = null;
        this._leftBarSprite = null;
        this._rightBarSprite = null;
        this._menuBtn = null;
        this._undoBtn = null;
        this._lastToolBtn = null;

        this._pencilButton = null;
        this._brushButton = null;
        this._bucketButton = null;
        this._stampButton = null;
        this._inkPotButton = null;
        this._sprayButton = null;
        this._eraserButton = null;
        this._paletteButton = null;

        this._drawItText = null;
        this._palettePanel = null;

        this._drawMode = CommonGame.TOOL.PENCIL;

        // Signals.
        this.signals = {};
        this.signals.onMenuClick = new signals.Signal();
        this.signals.onPaletteClick = new signals.Signal();
        this.signals.onDrawModeChanged = new signals.Signal();
    }

    init() {

        console.assert(Common.game.scene.palettePanel != null, "Initialization failed: Common.game.scene.palettePanel is null.");
        this._palettePanel = Common.game.scene.palettePanel;

        // Left bar.
        // Container.
        this._leftBarContainer = new PIXI.Container();
        this._leftBarContainer.anchor = new PIXI.Point(0, 0.5);
        this._leftBarContainer.x = Common.getScreenPositionLeft() - this.x;
        this.addChild(this._leftBarContainer);
        // Sprite.
        this._leftBarSprite = new PIXI.Sprite(Common.assets.getTexture("panel_l"));
        this._leftBarSprite.anchor = new PIXI.Point(0, 0.5);
        this._leftBarContainer.addChild(this._leftBarSprite);
        // Right bar.
        // Container.
        this._rightBarContainer = new PIXI.Container();
        this._rightBarContainer.anchor = new PIXI.Point(0, 0.5);
        this._rightBarContainer.x = Common.getScreenPositionRight() - this.x;
        this.addChild(this._rightBarContainer);
        // Sprite.
        this._rightBarSprite = new PIXI.Sprite(Common.assets.getTexture("panel_r"));
        this._rightBarSprite.anchor = new PIXI.Point(1, 0.5);
        this._rightBarContainer.addChild(this._rightBarSprite);

        //--buttons--//
        const buttonOffset = 90;//made an offset variable to use to offset the buttons

        // Menu button.
        //  var btnStatesAux = new P3.ButtonStates(
        ///     Common.assets.getTexture("btn_primary_small_off"),
        //     Common.assets.getTexture("btn_primary_small_over"),
        //    Common.assets.getTexture("btn_primary_small_down"),
        //    Common.assets.getTexture("icon_menu"));
        this._menuBtn = createButton("menu");
        this._menuBtn.anchor = new PIXI.Point(0.5, 0.5);
        this._menuBtn.y = -280;
        this._menuBtn.x = buttonOffset;
        this._menuBtn.overSoundName = "sfx_ui_rollover_00";
        this._menuBtn.downSoundName = "sfx_ui_click_00";
        this._menuBtn.signals.click.add(this._onMenuButton_Click, this);
        this._leftBarSprite.addChild(this._menuBtn);

        // Undo button.
        var btnStatesAux = new P3.ButtonStates(
            Common.assets.getTexture("icon_undo"),
            Common.assets.getTexture("icon_undo"),
            Common.assets.getTexture("icon_undo"));
        this._undoBtn = new P3.Button(btnStatesAux);
        this._undoBtn.anchor = new PIXI.Point(0.5, 0.5);
        this._undoBtn.y = -280;
        this._undoBtn.x = -buttonOffset;
        this._undoBtn.signals.click.add(this._onUndoButton_Click, this);
        this._rightBarSprite.addChild(this._undoBtn);

        this._undoBtn.interactive = false;
        this._undoBtn.alpha = 0.5;

        // Tool buttons.
        // Left.
        // Palette.
        this._paletteButton = new PaletteButton();
        this._paletteButton.init();
        this._paletteButton.anchor = new PIXI.Point(0.5, 0.5);
        this._paletteButton.y = 260;
        this._paletteButton.x = buttonOffset;
        this._paletteButton.scale.x = -1;
        this._paletteButton.signals.onClick.add(this._onPaletteBtn_Click, this);
        this._leftBarSprite.addChild(this._paletteButton);
        //this._arrToolBtn.push( this._colourPaletteButton );
        this._paletteButton.setup(Common.assets.getJSON("config").palettePanel.pages[0][0], CommonGame.TOOL.PENCIL);
        // Pencil.
        btnStatesAux = new P3.ButtonStates(
            Common.assets.getTexture("icon_pencil"),
            Common.assets.getTexture("icon_pencil"),
            Common.assets.getTexture("icon_pencil"));
        this._pencilButton = new P3.Button(btnStatesAux);
        this._pencilButton.anchor = new PIXI.Point(0.5, 0.5);
        this._pencilButton.y = 110;
        this._pencilButton.x = buttonOffset;
        this._pencilButton.drawMode = CommonGame.TOOL.PENCIL;
        this._pencilButton.signals.click.add(this._onDrawMode_Changed, this);
        this._leftBarSprite.addChild(this._pencilButton);
        // Brush.
        btnStatesAux = new P3.ButtonStates(
            Common.assets.getTexture("icon_brush"),
            Common.assets.getTexture("icon_brush"),
            Common.assets.getTexture("icon_brush"));
        this._brushButton = new P3.Button(btnStatesAux);
        this._brushButton.anchor = new PIXI.Point(0.5, 0.5);
        this._brushButton.y = -10;
        this._brushButton.x = buttonOffset;
        this._brushButton.drawMode = CommonGame.TOOL.BRUSH;
        this._brushButton.signals.click.add(this._onDrawMode_Changed, this);
        this._leftBarSprite.addChild(this._brushButton);
        // Bucket.
        btnStatesAux = new P3.ButtonStates(
            Common.assets.getTexture("icon_fill"),
            Common.assets.getTexture("icon_fill"),
            Common.assets.getTexture("icon_fill"));
        this._bucketButton = new P3.Button(btnStatesAux);
        this._bucketButton.anchor = new PIXI.Point(0.5, 0.5);
        this._bucketButton.y = -130;
        this._bucketButton.x = buttonOffset;
        this._bucketButton.drawMode = CommonGame.TOOL.BUCKET;
        this._bucketButton.signals.click.add(this._onDrawMode_Changed, this);
        this._leftBarSprite.addChild(this._bucketButton);
        // Right.
        // Stamp.
        btnStatesAux = new P3.ButtonStates(
            Common.assets.getTexture("icon_stamp"),
            Common.assets.getTexture("icon_stamp"),
            Common.assets.getTexture("icon_stamp"));
        this._stampButton = new P3.Button(btnStatesAux);
        this._stampButton.anchor = new PIXI.Point(0.5, 0.5);
        this._stampButton.scale.x = -1;
        this._stampButton.defaultScale.x = this._stampButton.scale.x;
        this._stampButton.y = 230;
        this._stampButton.x = -buttonOffset;
        this._stampButton.drawMode = CommonGame.TOOL.STAMP;
        this._stampButton.signals.click.add(this._onDrawMode_Changed, this);
        this._rightBarSprite.addChild(this._stampButton);
        // Ink pot.
        btnStatesAux = new P3.ButtonStates(
            Common.assets.getTexture("icon_ink"),
            Common.assets.getTexture("icon_ink"),
            Common.assets.getTexture("icon_ink"));
        this._inkPotButton = new P3.Button(btnStatesAux);
        this._inkPotButton.anchor = new PIXI.Point(0.5, 0.5);
        this._inkPotButton.y = 110;
        this._inkPotButton.x = -buttonOffset;
        this._inkPotButton.drawMode = CommonGame.TOOL.INK_POT;
        this._inkPotButton.signals.click.add(this._onDrawMode_Changed, this);
        this._rightBarSprite.addChild(this._inkPotButton);
        // Spray.
        btnStatesAux = new P3.ButtonStates(
            Common.assets.getTexture("icon_spray"),
            Common.assets.getTexture("icon_spray"),
            Common.assets.getTexture("icon_spray"));
        this._sprayButton = new P3.Button(btnStatesAux);
        this._sprayButton.anchor = new PIXI.Point(0.5, 0.5);
        this._sprayButton.y = -10;
        this._sprayButton.x = -buttonOffset;
        this._sprayButton.drawMode = CommonGame.TOOL.SPRAY;
        this._sprayButton.signals.click.add(this._onDrawMode_Changed, this);
        this._rightBarSprite.addChild(this._sprayButton);
        // Eraser.
        btnStatesAux = new P3.ButtonStates(
            Common.assets.getTexture("icon_eraser"),
            Common.assets.getTexture("icon_eraser"),
            Common.assets.getTexture("icon_eraser"));
        this._eraserButton = new P3.Button(btnStatesAux);
        this._eraserButton.anchor = new PIXI.Point(0.5, 0.5);
        this._eraserButton.y = -130;
        this._eraserButton.x = -buttonOffset;
        this._eraserButton.drawMode = CommonGame.TOOL.ERASER;
        this._eraserButton.signals.click.add(this._onDrawMode_Changed, this);
        this._rightBarSprite.addChild(this._eraserButton);

        // Draw it text (only for Draw It! mode).
        if (CommonGame.selectedGallery === CommonGame.GALLERY_ID_DRAW_IT) {
            this._drawItText = P3.createText(CommonGame.drawItTextId, {
                size: "64px",
                fill: [0xfff8b3, 0xfac109],
                stroke: 0x4c2607,
                strokeThickness: 4,
                padding: 20,
                wordWrapWidth: P3.View.width * 0.65
            }, "truetype", "draw_it");

            this._drawItText.y = -Common.STAGE_HEIGHT * 0.5 + 15;
            this._drawItText.anchor = new PIXI.Point(0.5, 0);
            this.addChild(this._drawItText);

            // Scale down.
            if (this._drawItText.width > Common.STAGE_MIN_WIDTH * 0.8) {
                var scaleFactor = ( Common.STAGE_MIN_WIDTH * 0.8 ) / this._drawItText.width;
                this._drawItText.y += ( 1 - scaleFactor ) * this._drawItText.height * 0.5;
                this._drawItText.scale = new PIXI.Point(scaleFactor, scaleFactor);
            }
        }

        // Initial state.
        this._highlightToolBtn(this._pencilButton);

        // Signals.
        Common.game.undoManager.signals.onStackEmpty.add(this._onUndoStack_Empty, this);
        Common.game.undoManager.signals.onStackIncreased.add(this._onUndoStack_Increased, this);

        this._palettePanel.signals.onColourChanged.add(this._onPaletteSelection_Changed, this);
        this._palettePanel.signals.onStampChanged.add(this._onPaletteSelection_Changed, this);
    }

    resize() {
        this._leftBarContainer.x = Common.getScreenPositionLeft() - this.x;
        this._rightBarContainer.x = Common.getScreenPositionRight() - this.x;
    }

    getPaletteBtnPosition() {
        return Common.findPositionInScene(this._paletteButton, Common.game.scene);
    }

    getBrushBtnPosition() {
        return Common.findPositionInScene(this._brushButton, Common.game.scene);
    }

    _highlightToolBtn(btn) {
        if (this._lastToolBtn) {
            // Remove outline.
            this._lastToolBtn.filters = [];

            TweenMax.killTweensOf(this._lastToolBtn.scale);
            this._lastToolBtn.animate = true;
            TweenMax.to(this._lastToolBtn.scale, 0.25, {
                x: this._lastToolBtn.scale.x < 0 ? -1 : 1,
                y: 1,
                ease: Sine.easeOut,
                onComplete: function (btn) {
                    btn.interactive = true;
                },
                onCompleteParams: [this._lastToolBtn]
            });
        }

        btn.animate = false;
        btn.interactive = false;
        btn.stopAnimations();
        TweenMax.to(btn.scale, 0.5, {
            x: 1.1 * ( btn.scale.x < 0 ? -1 : 1 ),
            y: 1.1,
            ease: Sine.easeInOut,
            yoyo: true,
            repeat: -1
        });

        this._lastToolBtn = btn;

        // Add outline.
        this._lastToolBtn.filters = [new OutlineFilter(9, 0xFFFFFF)];
    }

    //----EVENTS----//

    _onMenuButton_Click() {
        this.signals.onMenuClick.dispatch();
    }

    _onUndoButton_Click() {
        Common.game.undoManager.undo();


        // Sfx.
        Common.audio.playSound("sfx_tool_undo_step_back_00");
    }

    _onDrawMode_Changed(btn) {
        // Highlight selected button.
        this._highlightToolBtn(btn);

        this._drawMode = btn.drawMode;

        this.signals.onDrawModeChanged.dispatch(btn.drawMode);

        // Palette button.
        if (btn.drawMode == CommonGame.TOOL.ERASER)
        // Disable it if the eraser is selected.
            this._paletteButton.setInteractive(false);
        else {
            // Otherwise, enable it.
            this._paletteButton.setInteractive(true);

            // Update visual elements.
            if (btn.drawMode == CommonGame.TOOL.BUCKET)
                this._paletteButton.setup(Common.game.canvas.fillLayer.paletteItem, btn.drawMode);
            else
                this._paletteButton.setup(Common.game.canvas.drawLayer.drawingTool.paletteItem, btn.drawMode);
        }


        // Tutorial.
        Common.game.scene.addTutorialEvent(CommonGame.TUT_EVENT.TOOL_SELECTED);
        if (btn.drawMode != CommonGame.TOOL.ERASER)
            Common.game.scene.addTutorialEvent(CommonGame.TUT_EVENT.PALETTE_BUTTON_ENABLED);
        else
            Common.game.scene.addTutorialEvent(CommonGame.TUT_EVENT.PALETTE_BUTTON_DISABLED);
    }

    _onUndoStack_Empty() {
        this._undoBtn.interactive = false;
        this._undoBtn.alpha = 0.5;
    }

    _onUndoStack_Increased() {
        this._undoBtn.interactive = true;
        this._undoBtn.alpha = 1;
    }

    _onPaletteBtn_Click() {
        this.signals.onPaletteClick.dispatch(this._paletteButton.type);
    }

    _onPaletteSelection_Changed(selection, paletteType) {
        this._paletteButton.setup(selection, this._paletteButton.type);
    }
}